<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
  >
    <template v-slot:activator="{on, attrs}">
      <a
        :id="`openImg${image.id}`"
        v-bind="attrs"
        v-on="on"
      >
        <v-img
          :alt="image.category"
          :src="url"
          width="100"
          height="150"
          contain
        />
      </a>
    </template>
    <v-card>
      <v-app-bar>
        <v-btn
          id="menu"
          text
          @click.stop="drawer = !drawer"
        >
          <v-icon left>
            mdi-menu
          </v-icon>
          Imagens
        </v-btn>
        <v-spacer />
        <v-btn
          id="close"
          color="primary"
          text
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        absolute
        bottom
        temporary
      >
        <v-list
          nav
          dense
        >
          <v-list-item-group
            v-model="group"
          >
            <v-list-item
              v-for="(item, key) in items"
              :key="`item-${key}-${item.id}`"
              active-class="primary white--text"
            >
              <v-list-item-title
                @click="image = item"
              >
                {{ key + 1 }} - {{ item.category }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-card-text class="mt-10">
        <form-group>
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="6">
                  <v-slider
                    v-model="rotate"
                    min="0"
                    max="270"
                    label="Girar imagem"
                    color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <clipperFixed
                  ref="clipper"
                  class="my-clipper"
                  :src="url"
                  preview="my-preview"
                  :rotate="getRotate"
                >
                  <div
                    slot="placeholder"
                    class="placeholder"
                  >
                    No image
                  </div>
                </clipperFixed>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="6">
                  <v-slider
                    v-model="previewRotate"
                    :min="rotate || 0"
                    :max="(rotate * 3) || 360"
                    label="Girar imagem"
                    color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <div class="hiddenMax">
                  <div>preview:</div>
                  <clipper-preview
                    ref="preview"
                    name="my-preview"
                    class="my-clipper"
                  >
                    <div
                      slot="placeholder"
                      class="placeholder"
                    >
                      preview area
                    </div>
                  </clipper-preview>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </form-group>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import { clipperFixed } from 'vuejs-clipper';

export default {
  name: 'AnalysisImageModal',
  components: {
    clipperFixed,
    FormGroup,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          category: '',
          id: '',
          url: '',
        };
      },
    },
    documents: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: (vm) => ({
    dialog: false,
    url: '',
    image: vm.value,
    drawer: false,
    group: null,
    rotate: 0,
    previewRotate: 0,
  }),
  computed: {
    hasValue() {
      return this.value;
    },
    getRotate() {
      return this.rotate;
    },
    items() {
      return this.documents;
    },
  },
  watch: {
    image: {
      deep: true,
      immediate: true,
      handler(img) {
        if (img && img.url) {
          this.setReaderImageUrl(img.url);
        }
      },
    },
    hasValue: {
      deep: true,
      immediate: true,
      handler(img) {
        if (img && img.url) {
          this.setReaderImageUrl(img.url);
        }
      },
    },
  },
  methods: {
    setReaderImageUrl(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        this.url = reader.result;
      };
    },
  },
};
</script>

<style scoped>
.my-clipper, .my-preview {
  width: 100%;
  max-width: 600px;
  height: 100%;
}

.my-clipper {
  max-height: 500px!important;
}

.hiddenMax {
  width: 100%;
  height: 100%;
  max-width: 800px;
  max-height: 800px;
  overflow: hidden!important;
}
</style>
